
<template>
  <vs-popup class="holamundo" popup-class="w-9/12" :title='`ویرایش وضعیت پذیرنده "${name}"`' :active.sync="popupActive">
    <div class="vx-row mt-7 mb-12">
      <div class="vx-col w-full">وضعیت:</div>
      <div class="vx-col w-full">
        <v-select class="selectExample w-full" ref="ss1" :clearable="false" v-model="step" :options="draftStepList"></v-select>
      </div>
      <div class="vx-col w-full">
        <v-select class="selectExample w-full" ref="ss1" :clearable="false" v-model="state" :options="draftStateList"></v-select>
      </div>
    </div>
    <div class="vx-row mt-12 mb-11">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click="save">ذخیره</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="popupActive=false">انصراف</vs-button>
      </div>
    </div>
  </vs-popup>
</template>
<style>
</style>
<script>
import vSelect from "vue-select";
import { DraftStep,DraftState } from "@/enums.js";

export default {
  name: "edit-status-draft-merchant",
  props: {},
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      popupActive: false,
      DraftStep,
      DraftState,
      id: 0,
      name:'',
      state: {},
      step: {},
    };
  },
  computed: {
      draftStepList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.DraftStep)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
    draftStateList: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.DraftState)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
  },
  methods: {
    save() {
      let loading = this.$vs.loading();
      const payload={
        id:this.id,
        step:this.step.value,
        state:this.state.value,
      }
      this.$http
        .post("/api/services/app/Draft/EditStatus", payload)
        .then(response => {
          if (response.data.success) {
            this.popupActive = false;
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "پذیرنده با موفقیت تغییر وضعیت یافت"
            });
            this.$emit("success");
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    show(id,name,step,state) {
      this.id=id;
      this.name=name;
      this.step=this.draftStepList.find(
            x =>
              x.value ==step
          );
      this.state=this.draftStateList.find(
            x =>
              x.value ==state
          );
      this.popupActive = true;
    },
  },
  mounted() {}
};
</script>